import { ChangeDetectorRef, Directive, EventEmitter, inject, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { unsubscribeMixin } from '@shared/mixin/unsubscribe.mixin';
import { CalculationResultStatus, VersicherungspraemieCalculationResultDto } from '@backend/models';

@Directive()
export class DataBaseComponent extends unsubscribeMixin() implements OnDestroy {

  changeDetection = inject(ChangeDetectorRef);

  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  getPremiumColorCode(calculationResult: VersicherungspraemieCalculationResultDto | null): string {
    switch (calculationResult?.publicCalculationResultStatus) {
      case CalculationResultStatus.Ok:
        return 'green';
      case CalculationResultStatus.OkWithWarning:
        return 'yellow';
      case CalculationResultStatus.Error:
        return 'red';
    }

    return 'white';
  }

  protected setValueToForm<T>(control: FormControl<T>, value: T): void {
    control.setValue(value);
    this.changeDetection.detectChanges();
  }
}
